/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_2_DescInputs */

const en_mk_publish_2_desc = /** @type {(inputs: Mk_Publish_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish to an app address provided by Bystep. See its status and release history.`)
};

const id_mk_publish_2_desc = /** @type {(inputs: Mk_Publish_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan ke alamat aplikasi yang disediakan Bystep. Lihat status dan riwayat versinya.`)
};

/**
* | output |
* | --- |
* | "Publish to an app address provided by Bystep. See its status and release history." |
*
* @param {Mk_Publish_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_2_desc = /** @type {((inputs?: Mk_Publish_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_2_desc(inputs)
	return en_mk_publish_2_desc(inputs)
});